var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full"},[(_vm.gridOptions)?_c('vxe-grid',_vm._b({ref:"pricefluctuationsLog",attrs:{"loading":_vm.loading}},'vxe-grid',_vm.gridOptions,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }